import React from 'react';
import { DateTime } from 'luxon';
import { Text, View } from '@react-pdf/renderer';

import PdfTextBlockLeft from '../TextBlocks/PdfTextBlockLeft';
import PdfTextBlockBottom from '../TextBlocks/PdfTextBlockBottom';

import { DATE_FORMAT_DISPLAY, PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants';

const HeaderDetails = ({data}) => {
    return (
        <View
            style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "stretch",
                marginBottom: "20px"
            }}
        >
            <View
                style={{
                    width: "10%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <PdfTextBlockBottom title="Job ID" text={data.id} disableRightBorder={true} />
            </View>
            <View
                style={{
                    width: "10%",
                    marginRight: "10px",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <PdfTextBlockBottom title="Repeat" text={data.repeat ? data.repeat : "0"} />
            </View>
            <View
                style={{
                    width: "25%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockBottom title="Supplier" text={
                    data.supplier_name ? data.supplier_name : "-"
                } />
            </View>
            <View
                style={{
                    width: "15%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockBottom title="Inspector" text={
                    data.checker ? 
                    `${data.checker.name ? data.checker.name : ""} ${data.checker.sur_name ? data.checker.sur_name : ""}`
                    :
                    "-"   
                } />
            </View>
            
            <View
                style={{
                    width: "40%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <PdfTextBlockLeft disableBottomBorder title="Start Date" text={DateTime.fromISO(data.start_date).toFormat(DATE_FORMAT_DISPLAY)} />
                <PdfTextBlockLeft title="End Date" text={DateTime.fromISO(data.end_date).toFormat(DATE_FORMAT_DISPLAY)} />
            </View>
        </View>
    )
}

export default HeaderDetails